







import { Component, Vue, } from "vue-property-decorator";
import { auth } from "@/store/modules";
import EventExportCompact from './EventExportCompact.vue';
import EventExportDetailed from './EventExportDetailed.vue';

@Component({
  components: {
    EventExportCompact,
    EventExportDetailed,
  }
})
export class EventExport extends Vue {
  private isCompact: boolean = false;

  async created() {
    this.isCompact = auth.hasExportLock;
  }
}

export default EventExport;
